export default "__VITE_ASSET__jJn7kt9r__"